export default {
  en: {
    add_a_comment: 'Your comment...',
    add_a_reply: 'Your reply...',
    aria: {
      card_comment: 'Card comment',
      card_reply: 'Card reply',
    },
  },
};
